import RsaGestioneAmbulatoriale from "../";

const routes = [
	{
		name: "RsaGestioneAmbulatorialeListPage",
		path: "/rsagestioneambulatoriale",
		component: RsaGestioneAmbulatoriale.RsaGestioneAmbulatorialeListPage,
		meta: { title: "R.S.A. - Gestione Ambulatoriale" },
	},
];

export default routes;
